<template>
  <section>
    <!--工具条-->
    <Toolbar :buttonList="buttonList" @callFunction="callFunction"></Toolbar>

    <!--列表-->
    <el-table
      ref="listTable"
      :data="list"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      style="width: 100%"
      size="small"
    >
      <el-table-column :label="$t('Order.OrderNo')" width="160">
        <template slot-scope="scope">
          {{ scope.row.OrderNo }}
          <el-button
            type="primary"
            icon="el-icon-picture-outline"
            size="mini"
            circle
            @click="openImages(scope.row)"
          ></el-button>
        </template>
      </el-table-column>
      <el-table-column
        label="联系电话"
        prop="Phone"
        width="100"
      ></el-table-column>
      <el-table-column :label="$t('Enabled')" width="125">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="AuditStatus(scope.row.Eid)"
            :type="getStatusType(scope.row.Status)"
            disable-transitions
            v-if="scope.row.Status == 2"
            >{{ $t("Recharge.StatusList")[scope.row.Status] }}</el-button
          >
          <el-tag
            :type="getStatusType(scope.row.Status)"
            v-if="scope.row.Status != 2"
            effect="plain"
            >{{ $t("Recharge.StatusList")[scope.row.Status] }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="充值品类">
        <template slot-scope="scope">{{
          field(scope.row.Config.Name)
        }}</template></el-table-column
      >
      <el-table-column prop="PayType" :label="$t('PayMode')" width="90">
        <template slot-scope="scope">{{
          $t("Order.PayType." + scope.row.PayType)
        }}</template>
      </el-table-column>
      <el-table-column label="付款金额">
        <template slot-scope="scope">
          <span class="text_red">$ {{ scope.row.Amount }}</span></template
        ></el-table-column
      >
      <el-table-column label="充值金额">
        <template slot-scope="scope">
          <span class="text_powder">$ {{ scope.row.AddValue }}</span></template
        ></el-table-column
      >
      <el-table-column label="下单人" width="60">
        <template slot-scope="scope">
          <el-button
            size="small"
            @click="openUserInfo(scope.row.UserId)"
            type="info"
            icon="el-icon-user-solid"
            circle
            :loading="openUserInfoLoading"
          ></el-button>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('Order.SubmitTime')"
        prop="DateTime"
        width="100"
        fixed="right"
      >
        <template slot-scope="scope">{{
          formatDateTime(scope.row.Created)
        }}</template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="50"
        :total="total"
        style="float: right"
      ></el-pagination>
    </el-col>

    <!--转账截图-->
    <el-dialog
      :title="$t('Order.payImage')"
      :visible.sync="imagesVisible"
      v-model="imagesVisible"
      :close-on-click-modal="false"
    >
      <div>订单号：{{ openOrderInfo.OrderNo }}</div>
      <div>Fomo Order Id：{{ openOrderInfo.FomoOrderId }}</div>
      <div>Fomo Wallet Id：{{ openOrderInfo.FomoWalletId }}</div>
      <div class="text_red">支付：{{ openOrderInfo.Total }}</div>
      <div class="orderimage">
        <div
          class="imgblock"
          v-for="(value, key) in openOrderInfo.RechargeImage"
          :key="key"
        >
          <el-image
            style="width: 100px; height: 100px"
            :src="baseImgPathUrl + value.Path"
            :preview-src-list="rechargeSrcList"
          ></el-image>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="imagesVisible = false">{{
          $t("cancel")
        }}</el-button>
      </div>
    </el-dialog>

    <!--用户详细-->
    <el-dialog
      title="用户详细"
      :visible.sync="UserInfoVisible"
      v-model="UserInfoVisible"
      :close-on-click-modal="false"
      size="small"
      width="30%"
    >
      <el-form :model="userInfo" size="small">
        <div class="headview">
          <img v-bind:src="userInfo.headurl" class="headimg" />
          <div class="data">
            <div>{{ userInfo.name }}</div>
            <div>手机号码 ：{{ userInfo.phone }}</div>
            <div>
              余额 ：<span class="text_red">{{ userInfo.credit }}</span>
            </div>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="UserInfoVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "util/date";
import {
  base,
  getRecordList,
  getUserInfoById,
  editRechargeStatus,
} from "@/api/api";
import { getButtonList } from "@/promissionRouter";
export default {
  data() {
    return {
      filters: {
        name: "",
      },
      buttonList: [],
      list: [],
      total: 0,
      page: 1,
      listLoading: false,
      openUserInfoLoading: false,
      UserInfoVisible: false,
      userInfo: {},
      rechargeSrcList: [],
      imagesVisible: false,
      imagesLoading: false,
      openOrderInfo: { RechargeImage: [] },
      baseImgPathUrl: base + "/FileUpload/RechargeImage/a0/",
    };
  },
  methods: {
    formatDateTime: function (val) {
      return util.formatDate.format(new Date(val), "MM-dd hh:mm");
    },
    getStatusType(Status) {
      switch (Status) {
        case 1:
          return "primary";
        case 2:
          return "warning";
        case 3:
          return "danger";
        case 4:
          return "success";
        case 5:
          return "info";
      }
    },
    AuditStatus(eid) {
      this.$confirm("审核通过后将会为用户充值，请确认付款后操作", "审核确认", {
        type: "warning",
        distinguishCancelAndClose: true,
        confirmButtonText: "审核通过",
        cancelButtonText: "拒绝",
      })
        .then(() => {
          let para = {
            id: eid,
            status: 4,
          };
          editRechargeStatus(para).then((res) => {
            this.$message({
              message: "审核完成",
              type: "success",
            });
            this.getList();
          });
        })
        .catch((action) => {
          let para = {
            id: eid,
            status: 3,
          };
          editRechargeStatus(para).then((res) => {
            this.$message({
              message: "已拒绝",
              type: "success",
            });
            this.getList();
          });
        });
    },
    openRechargeConfig() {
      this.$refs.rechargeConfigDialog.loadData();
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    openUserInfo(uid) {
      let para = {
        id: uid,
      };
      this.openUserInfoLoading = true;
      getUserInfoById(para).then((res) => {
        this.userInfo = res.data.response;
        this.UserInfoVisible = true;
        this.openUserInfoLoading = false;
      });
    },
    openImages(row) {
      this.imagesVisible = true;
      let _this = this;
      this.rechargeSrcList = [];
      row.RechargeImage.forEach(function (item, index, array) {
        _this.rechargeSrcList.push(_this.baseImgPathUrl + item.Path);
      });
      this.openOrderInfo = row;
    },
    searchList() {
      this.page = 1;
      this.getList();
    },
    //获取用户列表
    getList() {
      let para = {
        page: this.page,
        key: this.filters.name,
      };
      this.listLoading = true;

      getRecordList(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.list = res.data.response.data;
        this.listLoading = false;
      });
    },
  },
  mounted() {
    this.getList();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

